import Icon from '../../components/Icon.vue'

Icon.register({"regular/id-badge":{"width":384,"height":512,"paths":[{"d":"M336 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V48C384 21.5 362.5 0 336 0zM336 464H48V48H336V464zM144 112H240C248.8 112 256 104.8 256 96S248.8 80 240 80H144C135.2 80 128 87.2 128 96S135.2 112 144 112zM192 288C227.3 288 256 259.3 256 224S227.3 160 192 160 128 188.7 128 224 156.7 288 192 288zM102.4 416H281.6C294 416 304 407.4 304 396.8V377.6C304 345.8 273.9 320 236.8 320 226 320 218.1 328 192 328 165.1 328 158.6 320 147.2 320 110.1 320 80 345.8 80 377.6V396.8C80 407.4 90 416 102.4 416z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/id-badge.js
// module id = c0Np
// module chunks = 0